"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrowSize = void 0;
var styles_1 = require("@material-ui/core/styles");
var theme_1 = __importDefault(require("../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
exports.arrowSize = 12;
var bottomAndTopArrowStyle = {
    width: exports.arrowSize * 2,
    height: exports.arrowSize,
};
var rightAndLeftArrowStyle = {
    width: exports.arrowSize,
    height: exports.arrowSize * 2,
};
exports.default = (0, makeStyles_1.default)(function () {
    return (0, styles_1.createStyles)({
        root: {
            borderRadius: 4,
            backgroundColor: 'white',
            maxHeight: "calc(100vh - ".concat(theme_1.default.topbarHeight, "px)"),
        },
        popper: function (_a) {
            var zIndex = _a.zIndex;
            return ({
                zIndex: zIndex,
                filter: "drop-shadow(".concat(theme_1.default.shadows.strongWithoutSpread, ")"),
            });
        },
        arrow: {
            position: 'absolute',
            overflow: 'hidden',
            pointerEvents: 'none',
            '&::before': {
                content: '""',
                display: 'block',
                width: exports.arrowSize * 2,
                height: exports.arrowSize * 2,
                background: 'white',
                borderRadius: 4,
            },
            '[x-placement*="bottom"] &': __assign(__assign({ top: 0, marginTop: -exports.arrowSize }, bottomAndTopArrowStyle), { '&::before': {
                    transform: 'rotate(45deg) translate(50%, 0%)',
                    transformOrigin: 'top center',
                } }),
            '[x-placement*="top"] &': __assign(__assign({ bottom: 0, marginBottom: -exports.arrowSize }, bottomAndTopArrowStyle), { '&::before': {
                    transform: 'rotate(45deg) translate(-50%, -50%)',
                } }),
            '[x-placement*="right"] &': __assign(__assign({ left: 0, marginLeft: -exports.arrowSize }, rightAndLeftArrowStyle), { '&::before': {
                    transform: 'rotate(45deg) translate(0%, -50%)',
                    transformOrigin: 'left center',
                } }),
            '[x-placement*="left"] &': __assign(__assign({ right: 0, marginRight: -exports.arrowSize }, rightAndLeftArrowStyle), { '&::before': {
                    transform: 'rotate(45deg) translate(-50%, 50%)',
                } }),
        },
    });
});
